// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MotivationalQuote_wrapper__s6u3l","content":"MotivationalQuote_content__3yD4s","text_container":"MotivationalQuote_text_container__fPtZn"};